import React from 'react';

export const statuses = [ 
    { id: 0, value: "Unattended", scl: 'signal-unatd', disabled: false },
    { id: 1, value: "Closed", scl: 'signal-close', disabled: false },
    { id: 2, value: "In progress", scl: 'signal-inpro', disabled: false },
    { id: 3, value: "Taken", scl: 'signal-gray', disabled: true },
    { id: 4, value: "Forwarded", scl: 'signal-gray', disabled: true },
];